// @ts-nocheck
/*
 * Port of views/dashboard/module/edit.js (origin/main-dev, 177 lines).
 * BYTE-IDENTICAL. Chrome swap: v1 <Card> â†’ shadcn.
 */
import { useState, useEffect } from 'react';
import { postApiCall, getApiCall } from '@/service/httpCall';
import { API_MODULE_EDIT } from '@/service/url';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/utilities/constant';
import RenderModuleForm from '@/features/module/ModuleForm';
import { useAuth, errorCheck } from '@/views/dashboard/auth/auth-utils';
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { ArrowLeft, Loader2, Save } from 'lucide-react';
import { Link } from 'react-router-dom';

function getApiUrl(url, id) {
  return url.replace(':id', id);
}

export default function ModuleEdit() {
  const { checkAuth } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [moduleName, setModuleName] = useState('');
  const [status, setStatus] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  useEffect(() => {
    const editApiUrl = getApiUrl(API_MODULE_EDIT, id);
    getApiCall(editApiUrl, {}).then(onGetSuccess).catch(onError);
  }, [id]);

  function onGetSuccess(resp) {
    setModuleName(resp.module_name);
    setStatus(resp.status);
  }

  function validateForm() {
    let valid = true;
    if (!moduleName.trim()) {
      valid = false;
      toast.error('Module Name required');
    }
    return valid;
  }

  async function submitForm(e) {
    e.preventDefault();
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    const params = {
      module_name: moduleName,
      // status:status
    };
    const editApiUrl = getApiUrl(API_MODULE_EDIT, id);
    postApiCall(editApiUrl, params).then(onModuleUpdateSuccess).catch(onModuleUpdateError);
  }

  function onModuleUpdateSuccess() {
    toast.success('Module updated successfully');
    setTimeout(() => {
      navigate(`/${ROUTES.MODULE.LIST}`);
    }, 1500);
  }

  function onModuleUpdateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(friendlyApiError(err));
    }
  }

  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(friendlyApiError(err));
    }
  }

  return (
    <ScrollPage>
      <PageHeader
        title="Update Module"
        description="Rename a module in the ACL master list."
        actions={
          <Button asChild variant="outline">
            <Link to={`/${ROUTES.MODULE.LIST}`}>
              <ArrowLeft className="h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />
      <Card className="p-4">
        <form
          onSubmit={async (e) => {
            submitForm(e);
          }}
        >
          <RenderModuleForm
            isEditMode={true}
            moduleName={moduleName}
            setModuleName={setModuleName}
            status={status}
            setStatus={setStatus}
          />

          <div className="mt-4 flex items-center justify-end gap-2">
            <Button asChild variant="ghost">
              <Link to={`/${ROUTES.MODULE.LIST}`}>Cancel</Link>
            </Button>
            <Button type="submit" disabled={buttonDisable}>
              {buttonDisable ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Save className="h-4 w-4" />
              )}
              {buttonDisable ? 'Updating…' : 'Save changes'}
            </Button>
          </div>
        </form>
      </Card>
    </ScrollPage>
  );
}
